import Vue from 'vue';

import {
  LayoutPlugin,
  FormPlugin,
  FormGroupPlugin,
  FormCheckboxPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormTextareaPlugin,
  FormSelectPlugin,
  NavbarPlugin,
  CollapsePlugin,
  DropdownPlugin,
  BadgePlugin,
  ImagePlugin,
  ButtonPlugin,
  VBTogglePlugin,
  VBScrollspyPlugin
} from 'bootstrap-vue';

Vue.use(LayoutPlugin);
Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormSelectPlugin);
Vue.use(NavbarPlugin);
Vue.use(CollapsePlugin);
Vue.use(DropdownPlugin);
Vue.use(BadgePlugin);
Vue.use(ImagePlugin);
Vue.use(ButtonPlugin);

Vue.use(VBTogglePlugin);
Vue.use(VBScrollspyPlugin);
